import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

interface SectionHeaderProps {
  title: string;
  count?: number;
  showExplore?: boolean;
  expanded?: boolean;
  onToggle?: () => void;
}

const SectionHeader = ({ title, count, showExplore, expanded, onToggle }: SectionHeaderProps) => (
  <div className="flex items-center justify-between px-1 pt-6 pb-3">
    {showExplore && onToggle ? (
      <button
        onClick={onToggle}
        className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground cursor-pointer"
      >
        {title}{count !== undefined && ` (${count})`}
      </button>
    ) : (
      <h2 className="text-sm font-medium text-muted-foreground">
        {title}{count !== undefined && ` (${count})`}
      </h2>
    )}
    {showExplore && onToggle && (
      <button
        onClick={onToggle}
        aria-label={expanded ? `Collapse ${title}` : `Expand ${title}`}
        className="text-muted-foreground transition-colors hover:text-foreground"
      >
        <motion.div
          animate={{ rotate: expanded ? 90 : 0 }}
          transition={{ duration: 0.25, ease: "easeInOut" }}
        >
          <ChevronRight className="h-4 w-4" />
        </motion.div>
      </button>
    )}
  </div>
);

export default SectionHeader;
